import {
  CheckInput,
  Select,
  TextAreaInput,
  TextInput,
} from '@octano/global-ui';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';

import SectionTitle from '../../../../../../components/text/SectionTitle';
import { useValidations } from '../../../../../../hooks/useValidations';
import { EbTypeItem } from '../../../api/partnership';

const prefix = 'tariffAndTuition.partnerships';

interface FormValues {
  name: string;
  partnershipType: string;
  description: string;
  applyAutomatically: boolean;
  discounts: { [key: string]: string };
}

interface PartnershipDataSectionProps {
  benefitTypes: EbTypeItem[];
}

const PartnershipDataSection = ({
  benefitTypes,
}: PartnershipDataSectionProps) => {
  const { t } = useTranslation();
  const { control } = useFormContext<FormValues>();
  const { msgValidations, validateTextNotEmpty } = useValidations();

  const typeOptions = benefitTypes.map((bt) => ({
    value: bt.id,
    label: bt.name,
  }));

  return (
    <>
      <Row className="mb-3">
        <Col xs="12">
          <SectionTitle text={t(`${prefix}.partnershipData`)} />
        </Col>
      </Row>

      <Row className="mb-3">
        <Col xs="12" md="6">
          <Select
            name="partnershipType"
            label={t(`${prefix}.partnershipType`)}
            placeholder={t(`${prefix}.partnershipTypePlaceholder`)}
            options={typeOptions}
            control={control}
            rules={{ required: msgValidations.required }}
          />
        </Col>
        <Col xs="12" md="6">
          <TextInput
            name="name"
            label={t(`${prefix}.partnershipName`)}
            placeholder={t(`${prefix}.partnershipPlaceholder`)}
            control={control}
            rules={{
              required: msgValidations.required,
              validate: validateTextNotEmpty,
            }}
          />
        </Col>
      </Row>

      <Row className="mb-4">
        <Col xs="12">
          <TextAreaInput
            name="description"
            label={t(`${prefix}.description`)}
            placeholder={t(`${prefix}.descriptionPlaceholder`)}
            control={control}
          />
        </Col>
      </Row>

      <Row className="mb-4">
        <Col xs="12">
          <CheckInput
            name="applyAutomatically"
            label={t(`${prefix}.applyAutomatically`)}
            control={control}
          />
        </Col>
      </Row>
    </>
  );
};

export default PartnershipDataSection;
